// extracted by mini-css-extract-plugin
export var footerNav = "Footer-module--footer-nav--1Thxf";
export var footerInfo = "Footer-module--footer-info--3zQVh";
export var copyright = "Footer-module--copyright--1Hu9f";
export var social = "Footer-module--social--v__g2";